module.exports = __webpack_public_path__ + "static/media/skin-health.c229076a.svg";